import { render, staticRenderFns } from "./StoCreateForm.vue?vue&type=template&id=34124bb6"
import script from "./StoCreateForm.vue?vue&type=script&lang=js"
export * from "./StoCreateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports